//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateContratos } from "@/typings/store/plugins/easyFirestore/contratos";

const getters: GetterTree<StateContratos, State> = {
    get(state) {
        return state.all;
    },
    getArray(state) {
        return Object.values(state.all);
    },
};

const contratos = {
    firestorePath: "dev/v1/contratos",
    firestoreRefType: "collection",
    moduleName: "contratos",
    statePropName: "all",
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: "%convertTimestamp%", // default
            updated_at: "%convertTimestamp%", // default
        },
    },
    state: {},
    getters,
    mutations: {},
    actions: {},
};

export default contratos;
